var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GmapMap',{ref:"mapRef",attrs:{"zoom":_vm.mapZoom,"center":{ lat: +_vm.CenterpointLatitude, lng: +_vm.CenterpointLongitude },"disableDefaultUI":true,"disableDoubleClickZoom":true,"options":{ minZoom: 10, maxZoom: 20 },"id":"map"}})
}
var staticRenderFns = []

export { render, staticRenderFns }